import { AvatarEntity } from '@datachain/ui-sdk/components/avatar';
import { immerable } from 'immer';

interface IAppPublicProjectViewEntity {
	projectLabel: string;
	pictoUrl: string;
	elemLabel: string;
	elemCode: string;
	elemId: number;
	characCount: number;
	depotCount: number;
	createdBy: AvatarEntity | null;
	createdOn: Date | null;
	updatedBy: AvatarEntity | null;
	updatedOn: Date | null;
}

const entityDefaults: IAppPublicProjectViewEntity = {
	characCount: 0,
	depotCount: 0,
	projectLabel: 'NO_PROJECT',
	pictoUrl: '',
	elemLabel: 'NO_ELEM',
	elemId: -1,
	elemCode: 'NO_CODE',
	createdBy: null,
	createdOn: null,
	updatedOn: null,
	updatedBy: null,
};

export class AppPublicProjectView implements IAppPublicProjectViewEntity {
	private [immerable] = true;
	public characCount = entityDefaults.characCount;
	public depotCount = entityDefaults.depotCount;
	public projectLabel = entityDefaults.projectLabel;
	public pictoUrl = entityDefaults.pictoUrl;
	public elemLabel = entityDefaults.elemLabel;
	public elemId = entityDefaults.elemId;
	public elemCode = entityDefaults.elemCode;
	public createdBy = entityDefaults.createdBy;
	public createdOn = entityDefaults.createdOn;
	public updatedOn = entityDefaults.updatedOn;
	public updatedBy = entityDefaults.updatedBy;

	public static build(
		params: Partial<IAppPublicProjectViewEntity> = {}
	): AppPublicProjectView {
		const instance = new AppPublicProjectView();
		instance.characCount = params.characCount ?? entityDefaults.characCount;
		instance.depotCount = params.depotCount ?? entityDefaults.depotCount;
		instance.projectLabel = params.projectLabel ?? entityDefaults.projectLabel;
		instance.pictoUrl = params.pictoUrl ?? entityDefaults.pictoUrl;
		instance.elemLabel = params.elemLabel ?? entityDefaults.elemLabel;
		instance.elemCode = params.elemCode ?? entityDefaults.elemCode;
		instance.elemId = params.elemId ?? entityDefaults.elemId;
		instance.createdBy = params.createdBy ?? entityDefaults.createdBy;
		instance.createdOn = params.createdOn ?? entityDefaults.createdOn;
		instance.updatedOn = params.updatedOn ?? entityDefaults.updatedOn;
		instance.updatedBy = params.updatedBy ?? entityDefaults.updatedBy;
		return instance;
	}
}
